import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { Dropdown } from 'core-components/library/dropdown'
import { Flex } from 'core-components/library/flex'
import { BaseCrud, Operator } from 'core-components/types'
import { useStaticCrud } from 'core-components/types/helpers'

import { WidgetTypes } from '../constants/widgetTypes'

import {
  extractFieldValueFromFilter,
  getFilterWithoutFieldFilter,
} from './groupFilter/helpers/filter'

interface IWidgetTypeFilter {
  source: BaseCrud
  onBlur: () => void
  field: string
  currentOperation: Operator
}

export const WidgetTypeFilter = ({
  source,
  onBlur,
  field,
  currentOperation,
}: IWidgetTypeFilter) => {
  const [currentFilterValue, setCurrentFilterValue] = useState(() => {
    const fieldValue = extractFieldValueFromFilter(source, field)
    return fieldValue === null ? '' : fieldValue.toString()
  })

  const statusCrud = useStaticCrud({
    data: Object.keys(WidgetTypes).map((type) => {
      return { key: type, value: type }
    }),
  })

  const apply = () => {
    if (currentFilterValue) {
      const newFilter = getFilterWithoutFieldFilter(source, field)

      newFilter.filters.push({
        field,
        value: currentFilterValue,
        operator: currentOperation,
      })

      source.setFilter(newFilter)
    }
    onBlur()
  }

  const clear = () => {
    source.setFilter(getFilterWithoutFieldFilter(source, field))
    onBlur()
  }

  return (
    <Flex flexDirection={'column'} className={'margin-top-sm'}>
      <Dropdown
        caption={'value'}
        source={statusCrud}
        onChange={setCurrentFilterValue}
        value={currentFilterValue}
      />
      <Flex justifyContent={'space-between'}>
        <Button onClick={apply} disabled={!currentFilterValue}>
          Apply
        </Button>
        <Button color={'danger'} variant={'text'} onClick={clear}>
          Clear
        </Button>
      </Flex>
    </Flex>
  )
}
